import {AccessorWithLatest, createAsync} from "@solidjs/router";
import {createContext, JSXElement, useContext} from "solid-js";
import {getMember} from "~/sdk/member";
import {Member} from "@gs-yoga/sdk/types";

const MemberContext = createContext<AccessorWithLatest<Member | null | undefined>>();

export default function MemberProvider(props: { children: JSXElement }) {

    const member = createAsync(async () => getMember())

    return (
        <MemberContext.Provider value={member}>
            {props.children}
        </MemberContext.Provider>
    );
}

export function useMember() {
    const context = useContext(MemberContext);
    if (!context) {
        throw new Error("useMember must be used within a MemberProvider")
    }
    return context
}